import { urlUpdated } from '../actions/url';
import { buildUrlQuery } from '../utils/QueryParamUtil';
export var updateUrl = function updateUrl() {
  return function (dispatch, getState) {
    var _state$gacOverAllInfo;
    var state = getState();
    var geoPath = (_state$gacOverAllInfo = state.gacOverAllInfo.selectedSuggestion) === null || _state$gacOverAllInfo === void 0 ? void 0 : _state$gacOverAllInfo.geoPath.uri;
    var origin = window.location.origin;
    var currentPage = state.search.currentPage || 1;
    var sorting = state.search.sorting;
    var newUrl = "".concat(origin, "/anbieter/immobilienmakler").concat(geoPath);
    var params = {};
    if (currentPage && currentPage > 1) {
      params['pagenumber'] = currentPage.toString();
    }
    if (sorting) {
      params['sortby'] = sorting.sortBy;
      params['sortorder'] = sorting.order || 'ASC';
    }
    var queryParams = buildUrlQuery(params);
    window.history.pushState({}, 'agent_web_search', "".concat(newUrl).concat(queryParams && queryParams.length > 0 ? "?".concat(queryParams) : ''));
    dispatch(urlUpdated());
  };
};